import { alpha, styled } from "@mui/system"

export const UiIconWrapper = styled("span", {
  name: "IconWrapper",
})(({ theme, color }) => ({
  color: theme.palette.text[`${color || "primary"}`],
  ...(color === "inherit"
    ? {
        color: "inherit",
      }
    : {}),
}))

export const UiUsabilityCounter = styled("span", {
  name: "UsabilityCounter",
})(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.primary.main,
  display: "inline-flex",
  alignItems: "center",
  gap: "8px",
  padding: theme.spacing(0.5, 1),
  borderRadius: 6,
  backgroundColor: alpha(theme.palette.primary.main, 0.16),
}))
